import bindAllMethods from '../../utils/bindAllMethods';
import { shouldPreloadAssetReferenceLocale } from '../mfeRouterService/operations/utils/shouldPreloadAssetReferenceLocale';
import ILayoutsService, * as T from './ILayoutsService';
import { InternalService } from '../../core/services';

export default class LayoutsService
  extends InternalService
  implements ILayoutsService
{
  private _globalPreloadAssetReferenceLocale = false;
  private _layoutList: T.LayoutsServiceConstructorOptionsType['layoutList'];
  defaultLayout: T.AssetPropertyType;

  constructor(options: T.LayoutsServiceConstructorOptionsType) {
    super();
    bindAllMethods(this);
    this._layoutList = options?.layoutList;

    if (options?.defaultLayoutKey) {
      this.defaultLayout = this.getLayoutByKey(options?.defaultLayoutKey);
    }
  }

  public setDependencies(
    options: T.LayoutServiceSetDependenciesPropsType | any
  ): void {
    // Support both custom and standard setDependencies signatures
    if (options?.services?.localization) {
      this._globalPreloadAssetReferenceLocale =
        !!options?.services?.localization?.isPreloadAssetReferenceLocale?.();
    }
    this._markAsReady();
  }

  public getLayoutByKey(key: string): T.AssetPropertyType {
    const currentLayout = this._layoutList?.find?.(
      (fallbackDescription) => fallbackDescription?.key === key
    );
    const willPreloadLocale = shouldPreloadAssetReferenceLocale({
      globalPreload: this._globalPreloadAssetReferenceLocale,
      localPreload: currentLayout?.preloadAssetReferenceLocale
    });
    if (typeof currentLayout === 'object') {
      currentLayout.preloadAssetReferenceLocale = willPreloadLocale;
    }

    return currentLayout;
  }
}
